/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Scene_Description_Jobs_FoundInputs */

const en_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No shot description jobs found for the selected period.`)
};

const fr_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun poste de description de prise de vue n'a été trouvé pour la période sélectionnée.`)
};

const de_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für den ausgewählten Zeitraum wurden keine Stellenangebote mit Aufnahmebeschreibung gefunden.`)
};

const it_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non sono state trovate descrizioni di lavori per il periodo selezionato.`)
};

const ru_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`За выбранный период не найдено заданий по описанию кадров.`)
};

const es_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron descripciones de trabajos de toma para el período seleccionado.`)
};

const zh_cn2_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所选时间段内未找到镜头描述工作。`)
};

const ja_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択した期間に該当する撮影説明の求人は見つかりませんでした。`)
};

const hi_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित अवधि के लिए कोई शॉट विवरण वाली नौकरियां नहीं मिलीं।`)
};

const pt_pt2_no_scene_description_jobs_found = /** @type {(inputs: No_Scene_Description_Jobs_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foram encontradas vagas de descrição de cenas para o período selecionado.`)
};

/**
* | output |
* | --- |
* | "No shot description jobs found for the selected period." |
*
* @param {No_Scene_Description_Jobs_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_scene_description_jobs_found = /** @type {((inputs?: No_Scene_Description_Jobs_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Scene_Description_Jobs_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_no_scene_description_jobs_found(inputs)
	if (locale === "de") return de_no_scene_description_jobs_found(inputs)
	if (locale === "it") return it_no_scene_description_jobs_found(inputs)
	if (locale === "ru") return ru_no_scene_description_jobs_found(inputs)
	if (locale === "es") return es_no_scene_description_jobs_found(inputs)
	if (locale === "zh-CN") return zh_cn2_no_scene_description_jobs_found(inputs)
	if (locale === "ja") return ja_no_scene_description_jobs_found(inputs)
	if (locale === "hi") return hi_no_scene_description_jobs_found(inputs)
	if (locale === "pt-PT") return pt_pt2_no_scene_description_jobs_found(inputs)
	return en_no_scene_description_jobs_found(inputs)
});